import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "¿Es digital?",
    a: "Sí. Recibirás acceso inmediato después de la compra y podrás acceder desde celular, tablet o computadora.",
  },
  {
    q: "¿Puedo imprimirlo?",
    a: "Sí. Los planificadores, listas de compras y materiales bonus fueron diseñados para imprimirse fácilmente.",
  },
  {
    q: "¿Sirve para niños selectivos?",
    a: "Sí. Muchas recetas fueron elegidas para ayudar a ampliar la aceptación de nuevos alimentos de forma gradual y positiva.",
  },
  {
    q: "¿Las recetas son fáciles?",
    a: "Sí. Las recetas están pensadas para madres ocupadas y utilizan ingredientes simples y accesibles.",
  },
  {
    q: "¿Está organizado por edad?",
    a: "Sí. El contenido está dividido desde los primeros alimentos hasta niños de 15 años.",
  },
  {
    q: "¿Cuándo recibo acceso?",
    a: "Inmediatamente después de completar el pago recibirás acceso al ebook y a todos los bonus.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-[#FBF4E7] py-20 md:py-32"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#849983]">
            Preguntas frecuentes
          </p>
          <h2 className="mt-4 font-serif-display text-4xl md:text-5xl tracking-tight leading-tight text-[#2A302A]">
            Todo lo que <em className="italic">necesitas saber</em>.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-14 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-[#E6E2D6] rounded-2xl px-6 py-1 shadow-[0_4px_20px_rgba(42,48,42,0.03)]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-serif-display text-lg md:text-xl text-[#2A302A] hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] leading-relaxed text-[#576057] pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
